import { clientDatumInfoBoxDataWithBoundsForSelection } from '@upright/ui/common/upright/core/impact-lens-profile/common/client-datums-to-boxes';
import { CarouselLayout } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { LeftAndRightImpactSelectionState } from '@upright/ui/common/upright/core/impact-lens-profile/selection-state/separate-left-right-selection-state';
import { ImpactInsight } from '@upright/ui/common/upright/core/impact-lenses/insights/common/types';
import { ClientDatumInfoBoxDataWithBounds } from '../../../impact-lens-profile/common/client-datums-to-boxes/types';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface InsightInfoBoxDataWithBounds extends ClientDatumInfoBoxDataWithBounds<ImpactInsight> {}

export function getInsightInfoBoxDataWithBoundsForSelection(
  baseLayout: CarouselLayout,
  insights: ImpactInsight[],
  lensIndex: number,
  previousLensIndex: number | undefined,
  selection: LeftAndRightImpactSelectionState,
): InsightInfoBoxDataWithBounds[] {
  return clientDatumInfoBoxDataWithBoundsForSelection(baseLayout, insights, lensIndex, previousLensIndex, selection);
}
